const DATE_TIME_FIELDS = new Set([
  'date',
  'time',
  'datetime',
  'timestamp',
  'created',
  'modified',
  'updated',
  'created_at',
  'updated_at',
  'modified_at',
  'created_date',
  'updated_date',
  'start_date',
  'end_date',
  'start_time',
  'end_time',
  'start',
  'start_',
  'end',
  'end_',
  'startdtg',
  'enddtg',
  'advdate',
  'createdate',
  'datecurrent',
  'polygondatetime',
  'todate',
  'fromdate',
  'firediscoverydatetime',
  'modifiedondatetime',
  'dateupdate',
  'date_update',
]);

export const formatValue = (value: unknown, fieldName?: string): string => {
  if (value === null || value === undefined) return '-';

  const isDateTimeField =
    fieldName && DATE_TIME_FIELDS.has(fieldName.toLowerCase());

  if (
    isDateTimeField &&
    (typeof value === 'string' || typeof value === 'number')
  ) {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return date.toLocaleString();
    }
  }

  if (typeof value === 'number') return value.toLocaleString();
  return String(value);
};

export const formatFieldName = (fieldName: string): string => {
  if (!fieldName) return '';

  // Replace underscores with spaces first
  const withSpaces = fieldName.replace(/_/g, ' ');
  // Insert spaces before camelCase boundaries and between acronym + word
  // Examples: "camelCase" -> "camel Case", "HTTPServer" -> "HTTP Server"
  const splitCamel = withSpaces
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');

  const words = splitCamel.split(' ');
  const formattedWords = words.map(word => {
    if (!word) return '';
    // Preserve all-caps acronyms (>=2 chars) as-is
    if (/^[A-Z]{2,}$/.test(word)) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return formattedWords.join(' ');
};

export const formatCoordinate = (coord: number | null | undefined): string => {
  if (coord === null || coord === undefined) return '-';
  return typeof coord === 'number' ? coord.toFixed(6) : '-';
};
